import { PAGE } from '@/constants/common';
import { IsPremium, RentType, TypeOfProperty } from '@/constants/others/rental-stamp-duty';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FormTypes } from '.';

export const initialState = {
  formField: {
    rentType: RentType.FIXED_RENT,
    leaseTerm: [
      {
        startDate: '',
        endDate: '',
        monthlyRent: 0,
        monthlyFurnitureFittings: 0,
        monthlyServiceMaintenance: 0,
        monthlyAdvertisingAndPromotion: 0,
        otherMonthlyCharges: 0,
      },
    ],
    isPremium: IsPremium.NO,
    typeOfProperty: TypeOfProperty.RESIDENTIAL,
    premiumAmtForResidential: 0,
    premiumAmtForNonResidential: 0,
    stampDutyResult: '',
  },
  loading: true,
  from: '' as PAGE | '',
};

export const rentalStampDutySlice = createSlice({
  name: 'rentalStampDuty',
  initialState,
  reducers: {
    updateDataForm: (
      state,
      action: PayloadAction<
        FormTypes & {
          from: PAGE | '';
        }
      >,
    ) => {
      const { from, ...rest } = action.payload;

      state.formField = rest;
      state.from = action.payload.from;
    },
    updateFrom: (state, action: PayloadAction<PAGE>) => {
      state.from = action.payload;
    },
    reset: () => {
      return initialState;
    },
  },
});

export const { updateDataForm, updateFrom, reset } = rentalStampDutySlice.actions;

export default rentalStampDutySlice.reducer;
